/* eslint-disable no-undef */
(function(){

    angular.module('tmx-app').controller('uploadDataCtrl', ['$stateParams', '$scope', '$mdDialog', 

        function UploadDataCtrl($stateParams, $scope, $mdDialog){
  
            var uploadDataVM=this;
            uploadDataVM.entity = $stateParams;
            uploadDataVM.showContent = true;
            uploadDataVM.fileUploaded = false;
            uploadDataVM.mappingCompleted = false;
            uploadDataVM.selectedTab = 0;
            uploadDataVM.previewData = "Please Select File";
            uploadDataVM.uploadedColumns = [];
            uploadDataVM.JsonData = {};
            uploadDataVM.gridData = new kendo.data.ObservableArray([]);
            uploadDataVM.mappedData = new kendo.data.ObservableArray([]);
            uploadDataVM.mappedColumns = new kendo.data.ObservableArray([]);
            uploadDataVM.kendoColumns = new kendo.data.ObservableArray([]);
  // uploadDataVM.availableEntities = [
  // {
  //   HiddenValue:0,
  //   VisibleValue:"Customer"
  // },
  // {
  //   HiddenValue:1,
  //   VisibleValue:"Company"
  // },
  // {
  //   HiddenValue:2,
  //   VisibleValue:"Users"
  // }
  // ];
            uploadDataVM.availableColumns = [
                {
                    HiddenValue:0,
                    VisibleValue:"CompanyCode"
                },
                {
                    HiddenValue:1,
                    VisibleValue:"CompanyName"
                },
                {
                    HiddenValue:2,
                    VisibleValue:"CompanyTypeLkp"
                }
            ];
  // uploadDataVM.availableColumns = resolvedData.gridColumn;
  // uploadDataVM.mappedColumns = uploadDataVM.availableColumns;
            uploadDataVM.mappedUploadedColumns = [];
            uploadDataVM.mappedAvailableColumns = uploadDataVM.availableColumns;
            $scope.uploadFile = function(files) {
                uploadDataVM.showContent = true;
                uploadDataVM.fileUploaded = true;
                var fd = new FormData();
    //Take the first selected file
                fd.append("file", files[0]);
 
                let i ,f;
                for (i = 0, f = files[i]; i != files.length; ++i) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        var data = e.target.result;

                        var workbook = XLSX.read(data, {type: 'binary'});
                        uploadDataVM.content = workbook.Strings;
      /* DO SOMETHING WITH workbook HERE */
                        var sheet_name_list = workbook.SheetNames;
                        sheet_name_list.forEach(function(y) { /* iterate through sheets */
                            var worksheet = workbook.Sheets[y];
        
                            uploadDataVM.previewData = XLSX.utils.sheet_to_csv(worksheet);
                            uploadDataVM.JsonData = XLSX.utils.sheet_to_json(worksheet);
        
                            var rows = uploadDataVM.previewData.split('\n');
                            var cols = rows[0].split(',');
                            for (let i  = 0; i < cols.length; i++) {
                                str = cols[i].replace(/\s/g, '');
                                uploadDataVM.kendoColumns.push({
                                    title: cols[i],
                                    field: str
                                });
                                uploadDataVM.uploadedColumns.push({
                                    HiddenValue: i,
                                    VisibleValue: cols[i]
                                })
                            }
                            for (var key in uploadDataVM.JsonData) {
                                if (uploadDataVM.JsonData.hasOwnProperty(key)) {
                                    uploadDataVM.gridData.push(uploadDataVM.JsonData[key]);
                                }
                            }
                            uploadDataVM.mappedUploadedColumns = uploadDataVM.uploadedColumns;
                        });
                    };
                    reader.readAsBinaryString(f);
                }

            };

            uploadDataVM.goToMapping = function() {
                uploadDataVM.selectedTab = 1;
            }

            uploadDataVM.goToFinal = function() {
  
                for (let i =0; i<uploadDataVM.availableColumns.length; i++) {
                    for (let j =i+1; j<uploadDataVM.availableColumns.length; j++) {
                        if(uploadDataVM.availableColumns[i].mappedColumn === uploadDataVM.availableColumns[j].mappedColumn) {
                            var confirm = $mdDialog.confirm()
              // .clickOutsideToClose(true)

                                .title('Mapping Conflict')
                                .textContent('Are you sure you want to map ' + uploadDataVM.availableColumns[i].VisibleValue + ' and ' + uploadDataVM.availableColumns[j].VisibleValue + ' to ' + uploadDataVM.uploadedColumns[j].VisibleValue +'?')
                                .ariaLabel('Lucky day')
              // .targetEvent(ev)
                                .ok('Yes')
                                .cancel('Cancel');

                            $mdDialog.show(confirm).then(function() {

                                uploadDataVM.selectedTab = 2;
                                uploadDataVM.mappingCompleted = true;
                            }, function() {
                                uploadDataVM.selectedTab = 1;
                                uploadDataVM.mappingCompleted = false;
                            });
      
                        }
                    } 
                }
                uploadDataVM.mappedData.splice(0, uploadDataVM.mappedData.length);
                uploadDataVM.selectedTab = 2;
                uploadDataVM.mappingCompleted = true;

                for(let i =0; i<uploadDataVM.availableColumns.length; i++) {
                    uploadDataVM.mappedColumns.push({
                        title: uploadDataVM.availableColumns.VisibleValue,
                        field: uploadDataVM.availableColumns.VisibleValue
                    });
                }

                for(let i =0; i<uploadDataVM.gridData.length; i++) {
                    var js = {};
                    for(let j=0; j<uploadDataVM.availableColumns.length; j++) {
                        var a = uploadDataVM.availableColumns[j].VisibleValue;
                        var b = uploadDataVM.availableColumns[j].mappedColumn;
                        var c = uploadDataVM.uploadedColumns[b].VisibleValue;
                        var d = uploadDataVM.gridData[i][c]; 
                        js[a] = d;
                    }
                    uploadDataVM.mappedData.push(js);
    
                }
  //show mapped preview
            }

            uploadDataVM.save = function() {
  //http call to send data (uploadDataVM.mappedData)
            }


            uploadDataVM.mainGridOptions = {
                sortable: true,
                pageable: true,
                
            };

            uploadDataVM.detail = new kendo.data.DataSource({ 
                data: uploadDataVM.gridData,   
                pageSize: 10
            });

            uploadDataVM.mappedDetail = new kendo.data.DataSource({ 
                data: uploadDataVM.mappedData,   
                pageSize: 10
            });

        }]);

})();